module.exports = __webpack_public_path__ + "img/Linkedin.b39e783d.svg";